import {
  ICouncilAgendaItem,
  ICouncilGuest,
  ICouncilSession,
} from "dto/Council/ICouncil";

// Backend Nota deserializuje KAŻDY przychodzący string przez HtmlEncodeConverter
// (Kwantum.LegalMail.Core/JsonConverters/HtmlEncodeConverter.cs — HttpUtility.HtmlAttributeEncode
// na Read), więc tekst wpisany przez użytkownika wraca zakodowany: `"` → &quot;, `&` → &amp;,
// `<` → &lt;. Tytuły punktów porządku obrad to zdania w rodzaju
// „Uchwała ws. zmiany uchwały nr „X" … & …" — bez odkodowania użytkownik zobaczyłby encje,
// a trafiłyby one także na publiczny portal radnego.
//
// Dekodujemy WYŁĄCZNIE te trzy encje, które produkuje HtmlAttributeEncode. Pełny dekoder
// (np. przez innerHTML) zamieniałby też encje wpisane przez użytkownika dosłownie.
// Runda tam i z powrotem jest stabilna: wpisane `"` → zapisane &quot; → pokazane `"` → zapisane &quot;.

export const decodeText = (value: string | null | undefined): string => {
  if (!value) return "";

  return value
    .replaceAll("&quot;", '"')
    .replaceAll("&lt;", "<")
    .replaceAll("&amp;", "&");
};

/** Punkty porządku obrad wraz z załącznikami — odkodowane pola tekstowe. */
export const decodeAgendaItems = (
  items: ICouncilAgendaItem[],
): ICouncilAgendaItem[] =>
  items.map((item) => ({
    ...item,
    Title: decodeText(item.Title),
    Description: item.Description ? decodeText(item.Description) : item.Description,
    Attachments: (item.Attachments ?? []).map((a) => ({
      ...a,
      Title: decodeText(a.Title),
      FileName: decodeText(a.FileName),
    })),
  }));

export const decodeSession = (session: ICouncilSession): ICouncilSession => ({
  ...session,
  Number: decodeText(session.Number),
  Title: decodeText(session.Title),
});

export const decodeGuest = (guest: ICouncilGuest): ICouncilGuest => ({
  ...guest,
  FirstName: decodeText(guest.FirstName),
  LastName: decodeText(guest.LastName),
  Role: decodeText(guest.Role),
});
